import styled from 'styled-components';

export const Content = styled.div`
  position: fixed;
  left: 50%;
  top: 1.5rem;
  font-size: 15px;
  /* right: 0px; */
  /* bottom: 1.5rem; */
  width: 884px; //595
  z-index: 9999;
  color: #fff;
  transform: translateX(-50%);
  background: #393e44;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.58);
  border-radius: 10px;
  * {
    box-sizing: border-box;
  }
  @media (max-width: 639px) {
    
  }
`;

export const ContentPreview = styled(Content)`
  width: 320px;
`;

export const Inner = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
`;

export const Header = styled.div`
  padding: 0.3rem 30px 0.3rem 0;
  height: 38px;
  line-height: 1;
  background-color: #1c2024;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.div`
  text-align: center;
`;

export const Left = styled.div`
  flex: 0 0 213px;
  max-width: 213px;
`;

export const Center = styled.div`
  flex-grow: 1;
`;

export const Right = styled.div`
  flex: 0 0 270px;
  max-width: 270px;
  margin-left: 1rem;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.2;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0 10px 0 0;
  transition: 0.15s all ease-in;
  border: 0;
  background-color: #090909;
  img {
    width: auto;
    height: 15px;
  }
  &:hover {
    background-color: #aaa;
  }
`;

export const NamePlace = styled.div`
  margin: 0 0 5px;
  /* padding-right: 1rem; */
  input {
    box-sizing: border-box;
    text-align: left;
    width: 100%;
    border-radius: 0 3px 3px 0;
    padding-left: 5px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1rem 1rem;
  button {
    border-radius: 10px;
  }
`;

export const ButtonsRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & > div,
  & > button {
    margin-left: 1rem;
  }
  & > div {
    position: relative;
    button {
      margin: 0;
    }
  }
`;

export const ControlsButtons = styled.div`
  padding: 1.1rem 1rem 0 0;
  button {
    width: 100%;
    border-radius: 10px;
  }
`;
